import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { paymentBankAccountQuery } from "../../services/payments/PaymentBankAccountQueryService";
import { queryKeys } from "@/utils/queryKeys";
const BANK_ACCOUNTS_SEARCH_LIMIT = 100;
export const usePaymentBankAccounts = subsidiaryId => {
  const $ = _c(7);
  let t0;
  if ($[0] !== subsidiaryId) {
    t0 = queryKeys.payments.bankAccounts(subsidiaryId);
    $[0] = subsidiaryId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== subsidiaryId) {
    t1 = () => paymentBankAccountQuery.search({
      search: {
        scopes: subsidiaryId ? [{
          name: "ofSubsidiary",
          parameters: [subsidiaryId]
        }] : [],
        sorts: [{
          field: "dealership",
          direction: "asc"
        }],
        limit: BANK_ACCOUNTS_SEARCH_LIMIT
      }
    });
    $[2] = subsidiaryId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};